import { render } from "./ListaFichEleccionesComponent.vue?vue&type=template&id=26194193"
import script from "./ListaFichEleccionesComponent.vue?vue&type=script&lang=js"
export * from "./ListaFichEleccionesComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/mac2/Herd/mix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__